import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { objectEntries, objectFromEntries, objectValues, satisfiesKey } from "@nens/shared-utils";

type FrontendSettings = {
  authorization_url: string;
  default_client_id: string;
  desktop_client_version: string;
  logout_url: string;
  maptiler_api_key: string;
  native_client_id: string;
  scope: string;
  token_url: string;
  hcc_url: string;
  extract_raster_dataset_process_id: string;
};

const FRONTEND_SETTINGS_MAP = satisfiesKey<keyof FrontendSettings>()({
  authorization_url: "authorizationUrl",
  default_client_id: "defaultClientId",
  desktop_client_version: "desktopClientVersion",
  logout_url: "logoutUrl",
  maptiler_api_key: "maptilerApiKey",
  native_client_id: "nativeClientId",
  scope: "scope",
  token_url: "tokenUrl",
  hcc_url: "hccUrl",
  extract_raster_dataset_process_id: "extractRasterDatasetProcessId",
} as const);

export function useFrontendSetting() {
  const query = useQuery(
    getRanaApiV1().getQueryOptions({
      ignoreTenant: true,
      queryKey: ["frontend-settings"],
      queryFn: async () =>
        (await getRanaApiV1().BaseApi.fetchJson("/frontend-settings")) as FrontendSettings,
    })
  );

  if (!query.isSuccess) {
    const { data, ...rest } = query;
    return {
      ...objectFromEntries(objectValues(FRONTEND_SETTINGS_MAP).map((key) => [key, null])),
      ...rest,
    } as const;
  }

  const { data, ...rest } = query;
  return {
    ...objectFromEntries(
      objectEntries(data).map(([key, value]) => [FRONTEND_SETTINGS_MAP[key], value])
    ),
    ...rest,
  } as const;
}
